import React, { useEffect, useState } from "react";
import imageP from "../../assets/images/maqueta/img11.jpg";
import fondoGrande from "../../assets/images/maqueta/img11.jpg";
import fondoChico from "../../assets/images/maqueta/img11.jpg";
import "./faqs.css";
import "bootstrap/dist/css/bootstrap.min.css";
import SearchIcon from "@mui/icons-material/Search";
import CardNews from "../news/CardNews";
import useBuscador from "../../hooks/useBuscador";
import { useNavigate } from "react-router-dom";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { Card } from "react-bootstrap";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  CardActionArea,
  CardContent,
  CardMedia,
  Typography
} from "@mui/material";
import useProduct from "../../hooks/useProduct";

const SearchResults = () => {
  const {
    busqueda,
    setBusqueda,
    resultadosBusqueda,
    totalSearchResult,
    suggestions,
    setSuggestions,
    HandleSearch,
  } = useBuscador();
  const { products, getAllProducts } = useProduct();

  useEffect(() => {
    getAllProducts({ onlyTitleAndIcon: false, visible: true });
  }, []);

  const arrayProductos = products?.filter(
    (prod) => prod?.deleted === false && prod?.visible === true && prod
  );

  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState("todos");
  const [searchProductos, setSearchProductos] = useState([]);
  const [searchSubProductos, setSearchSubProductos] = useState([]);
  const [busquedaNews, setBusquedaNews] = useState([]);
  const [searchFaqs, setSearchFaqs] = useState([]);
  const [searchEmpresa, setSearchEmpresa] = useState([]);
  const [searchEnElMundo, setSearchEnElMundo] = useState([]);
  const [inputText, setInputText] = useState("");
  const [timeoutId, setTimeoutId] = useState("");
  const [tituloBusqueda, setTituloBusqueda] = useState("");
  const [expanded, setExpanded] = React.useState("panel1");
  const navigate = useNavigate();

  const filteredSubProducts =
    arrayProductos?.length > 0
      ? searchSubProductos?.filter((subProd) => {
          return arrayProductos?.some(
            (prod) => String(prod?._id) === subProd?.productId && subProd
          );
        })
      : [];

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  useEffect(() => {
    // setShowSearch(!showSearch)
    setSuggestions([]);
    busqueda ? setTituloBusqueda(busqueda.search) : navigate("/");
  }, []);

  useEffect(() => {
    setSuggestions(resultadosBusqueda?.allWords || []);
  }, [resultadosBusqueda]);

  useEffect(() => {
    // setShowSearch(!showSearch)
    busqueda ? setTituloBusqueda(busqueda.search) : navigate("/");
  }, [busqueda]);

  useEffect(() => {
    if (resultadosBusqueda !== undefined && resultadosBusqueda !== null) {
      setSearchProductos(resultadosBusqueda?.products ? resultadosBusqueda.products : []);
      setSearchSubProductos(resultadosBusqueda?.subProducts ? resultadosBusqueda.subProducts : []);
      setBusquedaNews(resultadosBusqueda?.news ? resultadosBusqueda.news : []);
      setSearchFaqs(resultadosBusqueda?.faqs ? resultadosBusqueda.faqs : []);
      setSearchEmpresa(resultadosBusqueda?.business ? resultadosBusqueda.business : []);
      setSearchEnElMundo(resultadosBusqueda?.inTheWorld ? resultadosBusqueda.inTheWorld : []);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resultadosBusqueda]);

  const HandleClickSearchItem = (e) => {
    setSelected(e.target.value);
  };

  useEffect(() => {
    if (busqueda && busqueda.search.length >= 4) {
      clearTimeout(timeoutId); // Limpiar el temporizador existente
      const newTimeoutId = setTimeout(() => {
        HandleSearch();
        setSuggestions(resultadosBusqueda?.allWords);
      }, 1000); // Esperar 1000ms antes de realizar la búsqueda
      setTimeoutId(newTimeoutId); // Actualizar el ID del temporizador
    } else {
      setSuggestions([]);
    }
  }, [busqueda]);
  
  const handleInputSearchChange = ({ target }) => {
    setInputText(target.value);
    setBusqueda({ ...busqueda, search: target.value });
  };
  
  const HandleClickSearch = () => {
    // HandleSearch();
    // setTituloBusqueda(busqueda?.search);
  };

  const handleChange = (event) => {
    const selected = event.target.defaultValue.toLowerCase();
    setSelected(selected);
  };

  const handleChangefaqs = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  return !busqueda ? (
    navigate("/")
  ) : (
    <>
      <div id="faqs" className="search-results-bg bg-fullpage ">
        <img src={imageP} alt="" />

        <picture>
          <source
            media="(orientation: portrait) and (max-width: 767px)"
            srcSet={fondoChico}
            alt="header_calculadora"
            className="imagen-fondo img-responsive-inter"
            title="calculadora"
          />
          <source
            media="(orientation: landscape) and (max-width: 767px)"
            srcSet={fondoGrande}
            alt="header_calculadora"
            className="imagen-fondo img-responsive-inter"
            title="calculadora"
          />
          <img
            className="imagen-fondo img-responsive-inter"
            src={fondoGrande}
            alt="header_calculadora"
            title="calculadora"
          />
        </picture>

        <section className="container halfintro">
          <div className="search_result--container col-12 col-xl-9 col-lg-9 col-md-9 col-sm-12">
            <div className="row">
              <div className="col-md-12">
                <h1 className="">
                  {totalSearchResult !== 0 && `(${totalSearchResult})`}{" "}
                  {totalSearchResult === 1 ? `Resultado` : `Resultados`} de búsqueda para:{" "}
                  <strong>{tituloBusqueda}</strong>
                </h1>
              </div>
              <div>
                <p className="faqs__destacado">Realizar otra búsqueda</p>
                <div className="search-input--container form-floating search-input_container--white-border">
                  <input
                    type="text"
                    className="form-control search-input--white-border input-focus"
                    name="title"
                    id="title"
                    placeholder="Busqueda"
                    onChange={handleInputSearchChange}
                    value={tituloBusqueda}
                    maxLength={30}
                    minLength={2}
                    required
                    onKeyDown={(event) => {
                      if (event.key === "Enter") {
                        HandleClickSearch();
                      }
                    }}
                  />
                  {/* <label htmlFor="title">Realizar otra búsqueda </label> */}
                  <div
                    className="cursor-search"
                    onClick={HandleClickSearch}
                    to={`${inputText.length > 0 ? "/resultado-busqueda" : ""}`}
                  >
                    <SearchIcon />
                  </div>
                </div>
                  <ul className={`${suggestions?.length > 0 ? "list-style-none" : ""}`}>
                    {suggestions?.map((suggestion) => (
                      <li
                        key={suggestion}
                        onClick={() => {
                          setBusqueda({
                            ...busqueda,
                            search: suggestion,
                          });
                          setInputText(suggestion)
                          setTimeout(() => {
                            HandleClickSearch();
                            setSuggestions([]);
                          }, 1500);
                        }}
                      >
                        {suggestion}
                      </li>
                    ))}
                  </ul>
              </div>
            </div>
          </div>
        </section>
      </div>

      <section className="container settings__block-inferior ">
        <div className="container">
          <div className="select-none mt-2 mb-3">
            <p className="mt-2 me-3 font-filter">Filtrar por: </p>
            <select
              className="category-select"
              name="category_news"
              onChange={HandleClickSearchItem}
            >
              <option selected>Todos</option>
              <option value="news">Noticias</option>
              <option value="products">Productos</option>
              <option value="subProducts">SubProductos</option>
              <option value="business">Empresa</option>
              <option value="inTheWorld">En el mundo</option>
              <option value="faqs">Faqs</option>
            </select>
          </div>
          <FormControl className="category-check">
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
              defaultValue="todos"
            >
              <FormControlLabel
                value="todos"
                control={<Radio />}
                label="Todos"
                onChange={handleChange}
              />
              <FormControlLabel
                value="Productos"
                control={<Radio />}
                label="Productos"
                onChange={handleChange}
              />
              <FormControlLabel
                value="SubProductos"
                control={<Radio />}
                label="SubProductos"
                onChange={handleChange}
              />
              <FormControlLabel
                value="Noticias"
                control={<Radio />}
                label="Noticias"
                onChange={handleChange}
              />
              <FormControlLabel
                value="Faqs"
                control={<Radio />}
                label="Faqs"
                onChange={handleChange}
              />
              <FormControlLabel
                value="Business"
                control={<Radio />}
                label="Empresa"
                onChange={handleChange}
              />
              <FormControlLabel
                value="InTheWorld"
                control={<Radio />}
                label="En el mundo"
                onChange={handleChange}
              />
            </RadioGroup>
          </FormControl>
          <section className="mb-5">
            {searchProductos?.length === 0 &&
            filteredSubProducts?.length === 0 &&
            busquedaNews?.length === 0 &&
            searchFaqs?.length === 0 &&
            searchEmpresa?.length === 0 &&
            searchEnElMundo?.length === 0 ? (
              <div>
                <h3 className="mt-4">No hay resultados</h3>
              </div>
            ) : (
              <div>
                <div
                  className={`cards-search_result--container ${
                    selected === "productos" || selected === "todos" ? "" : "d-none"
                  }`}
                >
                  {searchProductos?.length > 0 ? (
                    <>
                      <h3>Productos</h3>
                      <div id="search_card" className="slide-Tenso-News">
                        <div className="search_card slide-Tenso-detail ">
                          <>
                            {searchProductos?.map((producto, index) => (
                              <Card
                                key={index}
                                sx={{ marginBottom: 3 }}
                                className="card_blog item_eh item mb-3"
                              >
                                <a href={`/producto/${producto?.title}`} className="redireccion">
                                  <CardActionArea>
                                    <CardMedia
                                      component="img"
                                      height="140"
                                      image={
                                        producto.imageProduct[0] ? producto.imageProduct[0].url : ""
                                      }
                                      // image={imgCardProduct}
                                      alt={
                                        producto.imageProduct[0] ? producto.imageProduct[0].alt : ""
                                      }
                                      title={producto?.title}
                                      className="homenews__img-card"
                                    />

                                    <CardContent className="pb-5 cards-style">
                                      {/* <article> */}
                                      <article className="title-card-noticia">
                                        <h3
                                          dangerouslySetInnerHTML={{
                                            __html: producto?.titleSearch
                                          }}
                                        ></h3>
                                      </article>
                                      <article>
                                        <p
                                          className="parrafo-noticias mt-2"
                                          dangerouslySetInnerHTML={{
                                            __html: producto?.top
                                          }}
                                        ></p>
                                      </article>
                                    </CardContent>
                                  </CardActionArea>
                                </a>
                              </Card>
                            ))}
                          </>
                        </div>
                      </div>
                    </>
                  ) : selected === "productos" ? (
                    <>
                      <h3>Productos</h3>
                      <h4>No se encontraron resultados</h4>
                    </>
                  ) : (
                    ""
                  )}
                </div>

                <div
                  className={`cards-search_result--container mb-4 ${
                    selected === "subproductos" || selected === "todos" ? "" : "d-none"
                  }`}
                >
                  {filteredSubProducts?.length > 0 ? (
                    <>
                      <h3>SubProductos</h3>
                      <div id="search_card" className="slide-Tenso-News">
                        <div className="slide-Tenso-detail search_card">
                          <>
                            {filteredSubProducts?.map((subProducto, index) => (
                              <Card
                                sx={{ marginBottom: 3 }}
                                className="card_blog item_eh item mb-3"
                                key={index}
                              >
                                <a
                                  href={`/producto/${subProducto?.productTitle}/${subProducto?.title}`}
                                  className="redireccion"
                                >
                                  <CardActionArea>
                                    <CardMedia
                                      component="img"
                                      height="140"
                                      image={
                                        subProducto.imageProduct[0]
                                          ? subProducto.imageProduct[0].url
                                          : ""
                                      }
                                      // image={imgCardProduct}
                                      alt={
                                        subProducto.imageProduct[0]
                                          ? subProducto.imageProduct[0].alt
                                          : ""
                                      }
                                      title={subProducto?.title}
                                      className="homenews__img-card"
                                    />

                                    <CardContent className="pb-5 cards-style">
                                      {/* <article> */}
                                      <article className="texto-slider pb-2">
                                        <p
                                          dangerouslySetInnerHTML={{
                                            __html: subProducto?.category
                                          }}
                                        ></p>
                                      </article>
                                      <article className="title-card-noticia">
                                        <h3
                                          dangerouslySetInnerHTML={{
                                            __html: subProducto?.titleSearch
                                          }}
                                        ></h3>
                                      </article>
                                    </CardContent>
                                  </CardActionArea>
                                </a>
                              </Card>
                            ))}
                          </>
                        </div>
                      </div>
                    </>
                  ) : selected === "subproductos" ? (
                    <>
                      <h3>SubProductos</h3>
                      <h4>No se encontraron resultados</h4>
                    </>
                  ) : (
                    ""
                  )}
                </div>
                <div
                  className={`cards-search_result--container ${
                    selected === "noticias" || selected === "todos" ? "" : "d-none"
                  }`}
                >
                  {busquedaNews?.length > 0 ? (
                    <>
                      <section className="container">
                        <h3>Noticias</h3>
                        <div className="slide-Tenso-News">
                          <div className="news-search slide-Tenso-detail">
                            {loading ? (
                              <>
                                <CardNews loading={true} tensoblog={true} />
                                <CardNews loading={true} tensoblog={true} />
                              </>
                            ) : (
                              <>
                                {busquedaNews?.map((noticia, index) => (
                                  <CardNews
                                    key={index}
                                    noticia={noticia}
                                    tensoblog={true}
                                    loading={loading}
                                    tensoblogClass={true}
                                    titleSearch={noticia?.titleSearch}
                                  />
                                ))}
                              </>
                            )}
                          </div>
                        </div>
                      </section>
                    </>
                  ) : selected === "noticias" ? (
                    <>
                      <h3>Noticias</h3>
                      <h4>No se encontraron resultados</h4>
                    </>
                  ) : (
                    ""
                  )}
                </div>
                <div
                  className={`cards-search_result--container mb-4 ${
                    selected === "faqs" || selected === "todos" ? "" : "d-none"
                  }`}
                >
                  {searchFaqs?.length > 0 ? (
                    <>
                      <h3>Faqs</h3>
                      <div className="">
                        <div className="faqs_search">
                          <>
                            {searchFaqs?.map((sfaq, index) => (
                              <div key={index} className="faqs_search-content">
                                <h4
                                  dangerouslySetInnerHTML={{
                                    __html: sfaq.category
                                  }}
                                ></h4>
                                {sfaq.faq?.map((item, index) => (
                                  <Accordion
                                    key={index}
                                    expanded={expanded === `panel${index}-${item._id}`}
                                    onChange={handleChangefaqs(`panel${index}-${item._id}`)}
                                  >
                                    <AccordionSummary id={`panel${index}d-header`}>
                                      <Typography
                                        dangerouslySetInnerHTML={{
                                          __html: item.question
                                        }}
                                      ></Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                      <Typography
                                        dangerouslySetInnerHTML={{
                                          __html: item.answer
                                        }}
                                      >
                                        {/* {faq.answer} */}
                                      </Typography>
                                    </AccordionDetails>
                                  </Accordion>
                                ))}
                              </div>
                            ))}
                          </>
                        </div>
                      </div>
                    </>
                  ) : selected === "faqs" ? (
                    <>
                      <h3>Faqs</h3>
                      <h4>No se encontraron resultados</h4>
                    </>
                  ) : (
                    ""
                  )}
                </div>
                <div
                  className={`cards-search_result--container mb-4 ${
                    selected === "business" || selected === "todos" ? "" : "d-none"
                  }`}
                >
                  {searchEmpresa?.length > 0 ? (
                    <>
                      <h3>Empresa</h3>
                      <div id="search_card" className="slide-Tenso-News">
                        <div className="slide-Tenso-detail search_card_business news-search">
                          <>
                            {searchEmpresa?.map((empresa, index) => (
                              <Card
                                key={index}
                                sx={{ marginBottom: 3 }}
                                className="card_blog item_eh item mb-3"
                              >
                                <a href="/somos-tensolite" className="redireccion">
                                  <CardActionArea>
                                    <CardMedia
                                      component="img"
                                      height="140"
                                      image={
                                        empresa.imageBusiness[0] ? empresa.imageBusiness[0].url : ""
                                      }
                                      // image={imgCardProduct}
                                      alt={
                                        empresa.imageBusiness[0] ? empresa.imageBusiness[0].alt : ""
                                      }
                                      title={empresa?.title}
                                      className="homenews__img-card"
                                    />

                                    <CardContent className="pb-5 cards-style">
                                      {/* <article> */}
                                      <article className="title-card-noticia">
                                        <h3>{empresa?.title}</h3>
                                      </article>
                                    </CardContent>
                                  </CardActionArea>
                                </a>
                              </Card>
                            ))}
                          </>
                        </div>
                      </div>
                    </>
                  ) : selected === "business" ? (
                    <>
                      <h3>Empresa</h3>
                      <h4>No se encontraron resultados</h4>
                    </>
                  ) : (
                    ""
                  )}
                </div>
                <div
                  className={`cards-search_result--container mb-4 ${
                    selected === "intheworld" || selected === "todos" ? "" : "d-none"
                  }`}
                >
                  {searchEnElMundo?.length > 0 ? (
                    <>
                      <h3>En el mundo</h3>
                      <div id="search_card" className="slide-Tenso-News">
                        <div className="slide-Tenso-detail news-search search_card_world">
                          <>
                            {searchEnElMundo?.map((world, index) => (
                              <>
                                <Card
                                  key={index}
                                  sx={{ marginBottom: 3 }}
                                  className="card_blog item_eh item mb-3"
                                >
                                  <a href="/somos-tensolite" className="redireccion">
                                    <CardActionArea>
                                      <CardContent className="pb-5 cards-style">
                                        {/* <article> */}
                                        <article className="title-card-noticia">
                                          <h3
                                            dangerouslySetInnerHTML={{
                                              __html: world?.title
                                            }}
                                          ></h3>
                                        </article>
                                      </CardContent>
                                    </CardActionArea>
                                  </a>
                                </Card>
                              </>
                            ))}
                          </>
                        </div>
                      </div>
                    </>
                  ) : selected === "intheworld" ? (
                    <>
                      <h3>En el mundo</h3>
                      <h4>No se encontraron resultados</h4>
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            )}
          </section>
        </div>
      </section>
    </>
  );
};

export default SearchResults;
